/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{assignRef as r}from"./assignRef.js";import{useCallbackRef as n}from"./useRef.js";function o(o,t){return n(t||null,(function(n){return o.forEach((function(o){return r(o,n)}))}))}export{o as useMergeRefs};
//# sourceMappingURL=useMergeRef.js.map
